import React from "react";
import { apiPath } from "./constants";
import classnames from "classnames";
import placeholder from "./placeholder.jpeg";

/* arr_c: null
arr_n: null
dist_n: null
mrc_c: "750"
mrc_n: "La Rivière-du-Nord"
mun_c: "75017"
mun_n: "Saint-Jérôme"
mun_type: "Ville"
nb_electeurs: "0"
nb_votes_candidat: null
nb_votes_rejetes: null
nom: "Pierre-Paul"
parti_n: "Avenir Saint-Jérôme - Équipe Marc Bourcier"
poste_c: "5"
prenom: "Carla"
reg_c: "15"
reg_n: "Laurentides"
sexe: "F"
sortant: "Nouvelle candidate"
statut_candidat_d: "Candidate"
type_poste_c: "CV"
type_poste_d: "Conseiller de ville"
img: "imgpath"
_full_text: "'0':33 '15':12 '5':14 '750':6 '75017':1 'avenir':26 'bourcier':32 'candidat':25,34 'carla':22 'conseiller':16 'cv':15 'de':17 'du':10 'f':23 'jérôme':4,29 'la':7 'laurentides':13 'marc':31 'nord':11 'nouveau':24 'paul':21 'pierre':20 'pierre-paul':19 'rivière':9 'rivière-du-nord':8 'saint':3,28 'saint-jérôme':2,27 'ville':5,18 'équipe':30"
_id: 9252 */
export const Candidat = ({
  prenom,
  nom,
  parti_n,
  type_poste_d,
  type_poste_c,
  poste_c,
  img,
  statut_candidat_d,
  nb_votes_candidat,

  hidePoste = false,
}) => {
  const elected = statut_candidat_d.split(' ').some(r => ["Élu", "Élue"].indexOf(r) >= 0)
  const desistement = statut_candidat_d === "Désistement";
  const vacant = statut_candidat_d === "Poste vacant";
  if (vacant) {
    return <div className={"tpe_candidat"}>
      <h4 className="tpe_candidat_fullname">Poste vacant</h4>
    </div>
  }
  return (
    <div className={classnames("tpe_candidat", elected && "tpe_candidat_isElected", desistement && "tpe_candidat_isDesistement")}>
      <div className="tpe_candidat_img">
        {img ? (
          <img src={`${apiPath}img/${img}`} alt="" />
        ) : (
          <img src={placeholder} alt />
        )}
      </div>
      <div className={"tpe_candidat_details"} >
        {desistement && <div className="tpe_candidat_desistement">Désistement</div>}
        <p className="tpe_candidat_parti">{parti_n}</p>
        <h4 className="tpe_candidat_fullname">
          {prenom} {nom}
        </h4>
        {!hidePoste && (
          <>
            <p className="tpe_candidat_poste">{type_poste_d}</p>
            {type_poste_c === "CV" ? (
              <p className="tpe_candidat_district">District {poste_c}</p>
            ) : null}
          </>
        )}
        {elected && <p className="tpe_candidat_elected_badge">{statut_candidat_d}</p>}
        <p className="tpe_candidat_vote_count">{nb_votes_candidat ? `${nb_votes_candidat} vote${parseInt(nb_votes_candidat) > 1 ? "s" : ""}` : "Aucun vote pour l'instant"}</p>
      </div>
    </div >
  );
};
